import Resource from './Resource'

class ParameterService extends Resource {
    async findVerifyClosedCassetteStatusIsActive(laboratoryId) {
        return this.findLaboratoryParameterByKey(laboratoryId, 'virtual.parameter.grossing.verifyClosedCassetteStatusIsActive')
    }

    async findInvalidateMaxTimeInHoursAfterValidation(laboratoryId) {
        return this.findLaboratoryParameterByKey(laboratoryId, 'configuration.parameter.laboratory.case.diagnosis.invalidateMaxTimeInHoursAfterValidation')
    }

    async findMaxMinutesLengthForDescriptionAudioRecordings(laboratoryId) {
        return this.findLaboratoryParameterByKey(laboratoryId, 'configuration.parameter.laboratory.module.maxMinutesLengthForDescriptionAudioRecordings')
    }

    async findCaseTranscriptionRequired(laboratoryId) {
        return this.findLaboratoryParameterByKey(laboratoryId, 'configuration.parameter.laboratory.case.transcriptionRequired')
    }

    async findAllMagazinesForCassettePrinting(laboratoryId) {
        const maxMagazineValue = Number(await this.findLaboratoryParameterByKey(laboratoryId, 'configuration.parameter.laboratory.grossing.maxNumberOfMagazinesForCassettePrinter'))
        const magazineOptions = []
        for (let magazine = 1; magazine <= maxMagazineValue; magazine++) {
            magazineOptions.push(magazine)
        }
        return magazineOptions
    }

    async findLaboratoryParameterByKey(laboratoryId, key) {
        const params = { key }
        const response = await this.axios.get(`/laboratories/${laboratoryId}/parameter`, { params })
        return response.data
    }
}

export default new ParameterService()
